export default __webpack_public_path__ + "static/media/onbord-home-icon.9985cb49.svg";